import React from "react";

const ProvenSec = () => {
  return (
    <section className="proven-sec curve-sec sec">
      <img src="/proven-exp-bg.png" alt="proven-bg" />
      <div className="container">
        <div className="row row-gap-25 align-items-center">
          <div className="col-lg-6 col-12">
            <h2 className="sec-head white">Proven Experiences</h2>
            <p className="para white mb-0">
              Our proven experiences showcase the real-world impact of our
              solutions across industries. From delivering seamless live sports
              coverage to enabling secure enterprise communications and ensuring
              disaster recovery readiness, each story reflects how we bring
              together technology, creativity, and reliability.
              <br />
              <br />
              More than just projects, these experiences demonstrate how we help
              clients connect, engage, and grow on a global scale — proving the
              value of solutions built to perform when it matters most.
            </p>
          </div>
          <div className="col-lg-6 col-12">
            <img
              src="/proven.png"
              className="w-100 h-auto"
              alt="proven-exp-img"
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default ProvenSec;
